import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3H_V1TF9us7os2EqegSY0nwdU2VACY7I",
  authDomain: "j1lists.firebaseapp.com",
  projectId: "j1lists",
  storageBucket: "j1lists.firebasestorage.app",
  messagingSenderId: "235126632446",
  appId: "1:235126632446:web:f1a622bff05b693e7d9aaf",
  measurementId: "G-R83D2R5P9P",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Email kontrolü için yeni fonksiyon
export const checkEmailExists = async (email) => {
  try {
    const signInMethods = await fetchSignInMethodsForEmail(auth, email);
    return signInMethods.length > 0; // Email kullanımdaysa true döner
  } catch (error) {
    console.error("Error checking email:", error);
    throw error;
  }
};

// Kullanıcı kayıt isteği oluşturma fonksiyonu
export const submitRegistrationRequest = async (
  username,
  email,
  facebookUrl = "",
  instagramUrl = ""
) => {
  try {
    // Username'i lowercase olarak kontrol et
    const lowerUsername = username.toLowerCase();

    // Kullanıcı adı kontrolü
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("usernameLower", "==", lowerUsername));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      throw new Error("This username is already in use");
    }

    // Email kontrolü
    const emailExists = await checkEmailExists(email);
    if (emailExists) {
      throw new Error("This email is already registered");
    }

    // Kayıt isteğini Firestore'a ekle
    await addDoc(collection(db, "registrationRequests"), {
      username: username,
      usernameLower: lowerUsername,
      email: email,
      facebookUrl: facebookUrl || "",
      instagramUrl: instagramUrl || "",
      status: "pending",
      createdAt: new Date(),
    });
  } catch (error) {
    throw error;
  }
};

// Username ile kullanıcı oluşturma fonksiyonu
export const createUserWithUsername = async (username, email, password) => {
  try {
    // Username'i lowercase olarak sakla
    const lowerUsername = username.toLowerCase();

    // Önce username'in kullanılabilir olduğunu kontrol et (case-insensitive)
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("usernameLower", "==", lowerUsername));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      throw new Error("This username is already in use");
    }

    // Firebase Auth'da kullanıcı oluştur
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;

    // Firestore'da kullanıcı dökümanını oluştur
    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      username: username, // Orijinal username
      usernameLower: lowerUsername, // Lowercase versiyonu
      email: email,
      createdAt: new Date(),
      updatedAt: new Date(),
    });

    return user;
  } catch (error) {
    throw error;
  }
};

// Login için username kontrolü fonksiyonu
export const getUserByUsername = async (username) => {
  try {
    const usersRef = collection(db, "users");
    const q = query(
      usersRef,
      where("usernameLower", "==", username.toLowerCase())
    );
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null;
    }

    return querySnapshot.docs[0].data();
  } catch (error) {
    console.error("Error getting user by username:", error);
    throw error;
  }
};

// Admin kontrolü için fonksiyon
export const checkIsAdmin = async (uid) => {
  try {
    const adminRef = collection(db, "admins");
    const q = query(adminRef, where("uid", "==", uid));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error("Admin check error:", error);
    return false;
  }
};

// Admin kullanıcısı için users collection'ında döküman oluştur
const createAdminUserDoc = async () => {
  try {
    const adminData = {
      uid: "Ldv7EZTf5zWftNigIMJNNMSDoG43",
      email: "j1listsinfo@gmail.com",
      username: "admin",
      usernameLower: "admin",
      role: "admin",
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    await setDoc(doc(db, "users", adminData.uid), adminData);
    console.log("Admin user document created successfully");
  } catch (error) {
    console.error("Error creating admin user document:", error);
  }
};

// Bu fonksiyonu bir kere çalıştırın
createAdminUserDoc();

// Mevcut kullanıcılar için migration fonksiyonu
const migrateExistingUsers = async () => {
  try {
    const usersRef = collection(db, "users");
    const snapshot = await getDocs(usersRef);

    const batch = writeBatch(db);

    snapshot.forEach((doc) => {
      const userData = doc.data();
      if (!userData.usernameLower && userData.username) {
        batch.update(doc.ref, {
          usernameLower: userData.username.toLowerCase(),
        });
      }
    });

    await batch.commit();
    console.log("User migration completed");
  } catch (error) {
    console.error("Migration error:", error);
  }
};

// Migration'ı çalıştır (bir kere çalıştırmanız gerekiyor)
migrateExistingUsers();

export { auth, db, storage };
export default app;
